module.exports = {
    extends: [
        '/',
        'templates',
        'bulk',
        'contentController'
    ],
}